import React from 'react';
import { map } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { MemberAddEditPaymentInformation } from 'ui/containers/MemberAddEditPaymentInformation';
import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { button as Button } from 'modules/button';

// success view
export const epostPaymentInformationStepSuccess = ( props ) => {
    
    return (
        <div className='ui-epost-payment-information-step'>
            
            <MemberAddEditPaymentInformation
                 enableSelection={ false }
                 { ...props }
            />

            <div className='ui-epost-payment-information-step__actions'>

                {
                    map( props.navActions, navAction => {
                        return (
                            <Button
                                key={ navAction.name }
                                className='ui-epost-payment-information-step__actions__action'
                                size='large'
                                showIcon={ true }
                                outline={ 'cancel' === navAction.name ? true: false }
                                { ...navAction }
                                onClick={ () => props.onNavActionClick( { action: navAction } ) }
                            />
                        );
                    } )
                }

            </div>
        </div>
    );
};

// set display name
epostPaymentInformationStepSuccess.displayName = 'epostPaymentInformationStepSuccess';

// set default props
epostPaymentInformationStepSuccess.defaultProps = {};

// prop types
epostPaymentInformationStepSuccess.propTypes = {};

/*******************************/


// Preloader
const epostPaymentInformationStepPreloader = ( ) => {
    return (
        <div className='ui-epost-payment-information-step-preloader'>
            <MemberAddEditAddresspreloader hideTitle={ true } />

            <div className='ui-epost-payment-information-step-preloader__actions'>
                <div className='ui-epost-payment-information-step-preloader__actions__action'></div>
                <div className='ui-epost-payment-information-step-preloader__actions__action'></div>
            </div>
        </div>
    );
};

// set display name
epostPaymentInformationStepPreloader.displayName = 'epostPaymentInformationStepPreloader';

// set default props
epostPaymentInformationStepPreloader.defaultProps = {};

// prop types
epostPaymentInformationStepPreloader.propTypes = {};

/******************************************** */

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { epostPaymentInformationStep as EpostPaymentInformationStep } from 'ui/views/widgets/epostPaymentInformationStep';
 *
 * // render
 * <EpostPaymentInformationStep propName='propValue'/>
 */
export const epostPaymentInformationStep = withNetworkState( epostPaymentInformationStepPreloader, epostPaymentInformationStepSuccess );
